import { SVGProps } from 'react';

const Redo2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 4 5 5-5 5m5-5H9.5a5.5 5.5 0 0 0 0 11H13"
    />
  </svg>
);
export default Redo2;
